import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import GoBackBtn from '../components/goBackBtn';
import RecordList from '../components/recordsPage/recordList';
import DatePickerRange from '../components/recordsPage/datePickerRange';
import ErrorModal from '../components/errorModal';
import Loading from '../components/loading';
import Modal from '@mui/material/Modal';
import FilterListIcon from '@mui/icons-material/FilterList';
import CancelIcon from '@mui/icons-material/Cancel';
import moment from 'moment';
import store from 'store-js';
import styles from '../styles/Records.module.scss';
import API from '../services/api';
import { useTranslation } from 'react-i18next';
import { useCookieState } from 'ahooks';
const modalStyle = {
    display: 'inline-grid',
    justifyContent: 'center'
};

const filterDatesStyle = {
    width: '180px',
    height: '40px',
    padding: '0px 7px',
    fontSize: '13.5px'
};

const convertDate = (date) => {
    return moment(date).format('DD/MM/YYYY');
};

const dateToMilliSec = (date) => {
    return moment(date, 'DD/MM/YYYY hh:mm').toDate().getTime();
};

export default function Records({ config }) {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const [token, setToken] = useCookieState('access_token', { secure: true, sameSite: 'strict' });

    const [loading, setLoading] = useState(true);

    const [today, setToday] = useState(null);
    const [desc, setDesc] = useState(true);
    const [openPicker, setOpenPicker] = useState(false);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    const [filtered, setFiltered] = useState(null);
    const [recordList, setRecordList] = useState([]);

    const [isLoadingHistory, setIsLoadingHistory] = useState(true);
    const [showServerErr, setShowServerErr] = useState(false);
    const [errModalMsg, setErrModalMsg] = useState(null);
    const [consoleMsg, setConsoleMsg] = useState(null);

    useEffect(() => {
        if (!token) navigate('/');
        setLoading(false);
        setToday(convertDate(new Date()));
    }, []);

    useEffect(() => {
        setTimeout(() => {
            if (today && token !== null) {
                let date = today.split('/');
                let queryDate = `${date[2]}-${date[1]}-${date[0]}`;
                queryHistory(queryDate, queryDate);
            }
        }, 500);
    }, [today, token]);

    useEffect(() => {
        if (recordList) setFiltered(recordList);
        /* Dummy Code Testing */
        // if (recordList?.length > 0) filterDateRange(today, today, "init");
    }, [recordList]);

    useEffect(() => {
        handleChangeOrder(filtered);
    }, [desc]);

    const queryHistory = (start, end) => {
        /* Dummy Code Testing */
        // Add a default dummy record
        // if (!store.get("records")) {
        //   let newRecordObj = {
        //     id: "queryHistory_1",
        //     redeemID: "data_example",
        //     date: moment(new Date()).subtract(3, "days").format("DD/MM/YYYY HH:mm"),
        //     coupons: [
        //       {
        //         product_name: "$100 Coupon[1]",
        //         product_value: 100,
        //         qty: 1,
        //       },
        //     ],
        //     total: 100,
        //     spending: 300,
        //     remarks: "redeem_remarks",
        //     receipt: "redeem_merchant_reference",
        //   };

        //   setRecordList([newRecordObj]);
        //   store.set("records", [newRecordObj]);
        //   // store.set("hasDefaultDummyRecord", true);
        // } else {
        //   setRecordList(store.get("records"));
        // }
        // setIsLoadingHistory(false);
        ////////////////////////////////////////////////////////////////////////////////////

        const api = new API(token);
        api.queryRedeemHistoryByDate(`${start} - ${end}`)
            .then((res) => {
                if (res && res.response.code === '200') {
                    let data = Object.values(res.payload);

                    // Sort desc order first
                    let ordered = [...data].sort((a, b) => b.created_time - a.created_time);

                    ordered.map((item) => {
                        let newObj = createRecordObj(item);
                        console.log({ newObj });
                        setRecordList((arr) => [...arr, newObj]);
                    });
                } else if (res && res.response.code === '400') {
                    setShowServerErr(true);
                    // setConsoleMsg(2);
                    console.log(res.response.message);
                } else if (res && res.response.code === '401') {
                    setShowServerErr(true);
                    setErrModalMsg(`${t(config.scannerErr_setting.errMsg.invalidToken)}`);
                }
                setIsLoadingHistory(false);
            })
            .catch((err) => {
                setShowServerErr(true);
                // setConsoleMsg(1);
                setIsLoadingHistory(false);
                console.log(err);
            });
    };

    // Create record list from api response
    const createRecordObj = (item) => {
        let arr = [];
        let couponArr;

        if (item.hasOwnProperty('loyalty_products') && !Array.isArray(item.loyalty_products)) {
            let lp = Object.values(item.loyalty_products);
            // console.log({ lp });
            lp.map((item) => {
                Object.values(item.vouchers).map((product) => {
                    arr.push({ ...product, min_spending_amount: item.min_spending_amount });
                });
            });
        }
        // // Group same coupon together & calculate qty & total value
        couponArr = arr.reduce(
            ((el) => {
                return function (newArr, obj) {
                    if (!el[obj.voucher_name])
                        newArr.push(
                            (el[obj.name] = {
                                name: obj.voucher_name,
                                // value: Number(obj.value_amount),
                                qty: 1,
                                min_spending_amount: obj.min_spending_amount
                            })
                        );
                    else el[obj.name].qty++;
                    return newArr;
                };
            })({}),
            []
        );

        // let totalAmt = 0;
        // for (let i of couponArr) {
        //   let value = i.value * i.qty;
        //   totalAmt += value;
        // }

        let newRecordObj = {
            id: item.id,
            redeemID: item.reference_id || item.id,
            date: moment(new Date(item.created_time * 1000)).format('DD/MM/YYYY HH:mm'),
            coupons: couponArr,
            total: Number(item.total_voucher_value),
            spending: Number(item.spending_amount).toString(),
            remarks: item.operator_remarks,
            receipt: item.metadata.receipt_no
                ? item.metadata.receipt_no[item.metadata.receipt_no.length - 1].value
                : null,
            receiptId: item.metadata.receipt_no
                ? item.metadata.receipt_no[item.metadata.receipt_no.length - 1].id
                : null,
            attachments: item.attachments,
            customer_id: item.customer_id
        };

        return newRecordObj;
    };

    const handleChangeOrder = (data) => {
        if (!data) return;
        if (desc) {
            let newOrder = [...data].sort((a, b) => dateToMilliSec(b.date) - dateToMilliSec(a.date));
            setFiltered(newOrder);
        } else {
            let newOrder = [...data].sort((a, b) => dateToMilliSec(a.date) - dateToMilliSec(b.date));
            setFiltered(newOrder);
        }
    };

    const filterDateRange = (start, end, type) => {
        const api = new API(token);

        setIsLoadingHistory(true);

        if (start && end) {
            /* Dummy Code Testing */
            // if (!type) {
            //   setStartDate(convertDate(start));
            //   setEndDate(convertDate(end));
            //   document.getElementById("filterBtn").innerText = `${convertDate(
            //     start
            //   )} - \n ${convertDate(end)}`;
            // } else {
            //   setStartDate(start);
            //   setEndDate(end);
            //   document.getElementById("filterBtn").innerText = `${start} - \n ${end}`;
            // }

            // let arr = [];
            // recordList.map((item) => {
            //   let d = item.date.split(" ")[0];
            //   if (
            //     (dateToMilliSec(d) < dateToMilliSec(end) &&
            //       dateToMilliSec(d) > dateToMilliSec(start)) ||
            //     dateToMilliSec(d) === dateToMilliSec(start) ||
            //     dateToMilliSec(d) === dateToMilliSec(end)
            //   ) {
            //     arr.push(item);
            //   }
            // });

            // setFiltered(arr);
            // setIsLoadingHistory(false);
            //////////////////////////////////////////////////////////////////

            setStartDate(convertDate(start));
            setEndDate(convertDate(end));

            //  Convert dates to YYYMMDD format
            let s = convertDate(start).split('/');
            let e = convertDate(end).split('/');
            let queryDate = `${s[2]}-${s[1]}-${s[0]} - ${e[2]}-${e[1]}-${e[0]}`;

            api.queryRedeemHistoryByDate(queryDate)
                .then((res) => {
                    if (res && res.response.code === '200') {
                        setFiltered(null);
                        let arr = [];
                        let data = Object.values(res.payload);
                        data.map((item) => {
                            let newObj = createRecordObj(item);
                            arr.push(newObj);
                        });
                        handleChangeOrder(arr);
                    } else if (res && res.response.code === '400') {
                        setShowServerErr(true);
                        // setConsoleMsg(2);
                        console.log(res.response.message);
                    } else if (res && res.response.code === '401') {
                        setShowServerErr(true);
                        setErrModalMsg(`${t(config.scannerErr_setting.errMsg.invalidToken)}`);
                    }

                    document.getElementById('filterBtn').innerText = `${convertDate(start)} - \n ${convertDate(end)}`;

                    setIsLoadingHistory(false);
                })
                .catch((err) => {
                    setShowServerErr(true);
                    // setConsoleMsg(1);
                    setIsLoadingHistory(false);
                    console.log(err);
                });
        } else {
            setStartDate(null);
            setEndDate(null);
            handleChangeOrder(recordList);
            setIsLoadingHistory(false);
            document.getElementById('filterBtn').innerText = `${today} - \n ${today}`;
        }
    };

    const handleNumUpdate = (id, receiptNum) => {
        console.log(id, receiptNum);
        filtered.find((item) => {
            console.log(item);
            if (item.id === id) {
                return (item.receipt = receiptNum);
            }
        });
    };

    // When update Receipt num. fails
    const handleErr = (msg) => {
        if (msg === 3) {
            setShowServerErr(true);
            return setErrModalMsg('invalid_token');
        }

        setErrModalMsg(msg);
        setShowServerErr(true);
    };

    const handleClosePicker = () => {
        setOpenPicker(false);
    };

    const handleOpen = () => {
        setOpenPicker(true);
    };

    const handleCloseErrModal = () => {
        setShowServerErr(false);
        setErrModalMsg(null);
        setConsoleMsg(null);
    };

    return (
        <div className="marginContent">
            <div className="content noselect">
                <div className="backBtnDiv">
                    <GoBackBtn color={config.theme.color} />
                </div>

                <div className="list">
                    <div className={styles.titleDiv}>
                        <h3>{t('recordsPage_title')}</h3>
                        <button
                            type="button"
                            id="filterBtn"
                            className={styles.filterBtn}
                            style={filterDatesStyle}
                            onClick={handleOpen}
                        >
                            {today} - <br />
                            {today}
                        </button>
                        <FilterListIcon className={styles.filterIcon} onClick={() => setDesc(!desc)} />
                        <Modal open={openPicker} onClose={handleClosePicker} style={modalStyle}>
                            <div className={styles.datePickerDiv}>
                                <CancelIcon style={{ float: 'right', color: '#c8c8c8' }} onClick={handleClosePicker} />
                                <DatePickerRange
                                    openPicker={openPicker}
                                    filterDateRange={filterDateRange}
                                    startDatePicked={startDate ? moment(startDate, 'DD/MM/YYYY, HH:mm').toDate() : null}
                                    endDatePicked={endDate ? moment(endDate, 'DD/MM/YYYY, HH:mm').toDate() : null}
                                />
                            </div>
                        </Modal>
                    </div>

                    {isLoadingHistory ? (
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                marginTop: '50px'
                            }}
                        >
                            <Loading color={'#41413A'} />
                        </div>
                    ) : (
                        <RecordList
                            data={filtered}
                            handleErr={handleErr}
                            handleUpdated={handleNumUpdate}
                            t={t}
                            config={config}
                        />
                    )}
                </div>

                <ErrorModal
                    openModal={showServerErr}
                    errorMsg={errModalMsg}
                    consoleMsg={consoleMsg}
                    handleCloseModal={handleCloseErrModal}
                    t={t}
                    config={config}
                />
            </div>

            {loading && <Loading />}
        </div>
    );
}
